/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Select_GrowerInputs */

const vi_weighing_select_grower = /** @type {(inputs: Weighing_Select_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn hộ trồng chè`)
};

/**

* @param {Weighing_Select_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_select_grower = /** @type {((inputs?: Weighing_Select_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Select_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_select_grower(inputs)
});